export const ProgressBar = ({ progress }: { progress: number }) => (
  <div className="z-[21] h-[4px] w-full overflow-hidden rounded-[19px] bg-primary-100">
    <div
      className="h-full bg-gradient-to-r from-[#2196F3] to-[#CC41D3]"
      style={{
        width: `${progress}%`,
      }}
    />
  </div>
);
